export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  INTERNAL_CHAT_MENTION: ['i-lucide-at-sign', 'text-n-ruby-11'],
  INTERNAL_CHAT_NEW_MESSAGE: ['i-lucide-message-square', 'text-n-blue-11'],
};

export const INTERNAL_CHAT_NOTIFICATION_TYPES = [
  'internal_chat_mention',
  'internal_chat_new_message',
];

export const isInternalChatNotification = notification => {
  const type =
    notification?.notification_type || notification?.notificationType;
  return INTERNAL_CHAT_NOTIFICATION_TYPES.includes(type);
};

export const buildInternalChatNotificationRoute = (notification, accountId) => {
  const actor = notification?.primary_actor || notification?.primaryActor || {};
  const secondary =
    notification?.secondary_actor || notification?.secondaryActor;
  const channelType = actor.channel_type || actor.channelType;
  const channelId = actor.id;
  const messageId = secondary?.id;

  return {
    name: channelType === 'dm' ? 'internal_chat_dm' : 'internal_chat_channel',
    params: { accountId, channelId },
    ...(messageId ? { query: { messageId } } : {}),
  };
};
